export default __webpack_public_path__ + "static/media/youngman.44ec9649.svg";